export const environment = {
  production: false,
  appName: 'WebAttendix',
  // apiBaseUrl: 'http://localhost:3000',
  apiBaseUrl: 'https://development-attendix.razz-dev.com',
};
